export const SERVER_ERROR_MESSAGE = 'Something went wrong.';

export const UPDATE_USER_DETAILS_SUCCESSFULLY = 'Your details have been updated successfully.';
export const CHANGE_PASSWORD_SUCCESSFULLY = 'Your password has been updated successfully.';

export const USER_REGISTRATION_SUCCESSFULLY = 'Your registration has been complete. You can sign in after verifying your email address.';

export const RESEND_EMAIL_VERIFICATION_SUCCESSFULLY = 'The verification email has been resent to the given address.';

export const SIGN_IN_USER_SUCCESSFULLY = 'The user has been signed in successfully.';
export const SIGN_OUT_USER_SUCCESSFULLY = 'The user has been signed out successfully.';

export const RESET_PASSWORD_SUCCESSFULLY = 'The password has been reset successfully.';

export const FORGOT_PASSWORD_SUCCESSFULLY = 'An email with more information about how to.';

export const UPGRADE_TO_TICKETING_ACCOUNT_SUCCESSFULLY = 'Your account has been upgraded successfully.';

export const PASSWORD_RESET_REQUIRED = 'We have made some changes to our system to improve your experience. This requires you to create a new password, please do this by clicking on the \'Forgotten Password\' below.';

export const MUST_CONFIRM_EMAIL_MESSAGE = 'Your email is not confirmed, please check your email and confirm your registration.';

export const MISSING_USER = 'User does not exist. Please register above.';
